import { render, staticRenderFns } from "./SimpleAudio.vue?vue&type=template&id=0ee26998"
import script from "./SimpleAudio.vue?vue&type=script&lang=js"
export * from "./SimpleAudio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ee26998')) {
      api.createRecord('0ee26998', component.options)
    } else {
      api.reload('0ee26998', component.options)
    }
    module.hot.accept("./SimpleAudio.vue?vue&type=template&id=0ee26998", function () {
      api.rerender('0ee26998', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/student/vue/nieuwsmaker/components/SimpleAudio.vue"
export default component.exports